import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utilities/axios";

export const getMonthEndBalanceSheetItems = createAsyncThunk(
  "monthEndBalanceSheetItems/getMonthEndBalanceSheetItems",
  async ({ projectId, month }, thunkAPI) => {
    try {
      const response = await axios.get(
        `/api/projects/${projectId}/month-end-balance-sheet-items`,
        {
          params: { month },
        }
      );

      if (response.status === 200) {
        return response.data;
      }

      throw new Error(response.statusText);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  data: null,
  status: "idle",
  error: null,
};

const slice = createSlice({
  name: "monthEndBalanceSheetItems",
  initialState,
  reducers: {
    resetMonthEndBalanceSheetItems: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMonthEndBalanceSheetItems.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getMonthEndBalanceSheetItems.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
        state.error = null;
      })
      .addCase(getMonthEndBalanceSheetItems.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetMonthEndBalanceSheetItems } = slice.actions;

export const reducer = slice.reducer;

export default slice;

